import { LoadableLazy } from '@confluence/loadable';
import type { LoadableType } from '@confluence/loadable';
import type { LoomMigrationModalManagerComponentProps } from '../src/LoomMigrationModalManager';

export const LoomMigrationModalManager: LoadableType<LoomMigrationModalManagerComponentProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-LoomMigrationModalManager" */ '../src/LoomMigrationModalManager'
				)
			).LoomMigrationModalManager,
	});
